<script setup>
defineProps({
  title: { type: String, default: '' },
  items: { type: Array, default: () => [] } // Array of [title, desc, svgPathD]
})
</script>

<template>
  <section class="block tight">
    <div class="wrap">
      <div class="sec-h"><h2>{{ title || 'Why use this free tool' }}</h2></div>
      <div class="why-grid">
        <div v-for="(item, i) in items" :key="i" class="why-card">
          <div class="wi">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path :d="item[2]" />
            </svg>
          </div>
          <h4>{{ item[0] }}</h4>
          <p>{{ item[1] }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
